import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import RouterSideNavItem from 'ui-addon-react-router-dom/RouterSideNavItem';
import { useIsSeatsUser } from '../hooks/useUserInfo';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledRouterSideNav = ({
  Title,
  routePath
}) => {
  return /*#__PURE__*/_jsx(RouterSideNavItem, {
    title: /*#__PURE__*/_jsx(Text, {
      textWrap: "nowrap",
      children: Title
    }),
    to: `/internal-development${routePath}`,
    padding: "400",
    marginInlineStart: "300",
    "data-selenium-class": "side-nav",
    "data-test-id": `side-nav-${routePath}`
  });
};
export const CustomerPlatformSideNavItem = () => {
  return /*#__PURE__*/_jsx(StyledRouterSideNav, {
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.pagesV2.customerPlatform.tabTitle"
    }),
    routePath: "/suite"
  });
};
export const FreeToolsSideNavItem = () => {
  return /*#__PURE__*/_jsx(StyledRouterSideNav, {
    routePath: "/crm",
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.pagesV2.crm.tabTitle"
    })
  });
};
export const BundleSideNavItem = () => {
  return /*#__PURE__*/_jsx(StyledRouterSideNav, {
    routePath: "/bundle",
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.pages.products.tabs.bundle.tabTitle"
    })
  });
};
export const MarketingPlusSideNavItem = () => {
  return /*#__PURE__*/_jsx(StyledRouterSideNav, {
    routePath: "/marketing-plus",
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.pagesV2.marketingPlus.tabTitle"
    })
  });
};
export const MarketingSideNavItem = () => {
  return /*#__PURE__*/_jsx(StyledRouterSideNav, {
    routePath: "/marketing",
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.pagesV2.marketing.tabTitle"
    })
  });
};
export const SalesSideNavItem = () => {
  return /*#__PURE__*/_jsx(StyledRouterSideNav, {
    routePath: "/sales",
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.pagesV2.sales.tabTitle"
    })
  });
};
export const ServiceSideNavItem = () => {
  return /*#__PURE__*/_jsx(StyledRouterSideNav, {
    routePath: "/service",
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.pagesV2.service.tabTitle"
    })
  });
};
export const ContentSideNavItem = () => {
  return /*#__PURE__*/_jsx(StyledRouterSideNav, {
    routePath: "/content",
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.pagesV2.content.tabTitle"
    })
  });
};
export const DataSideNavItem = () => {
  return /*#__PURE__*/_jsx(StyledRouterSideNav, {
    routePath: "/data",
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.pagesV2.data.tabTitle"
    })
  });
};
export const CommerceSideNavItem = () => {
  const isSeatsUser = useIsSeatsUser();
  if (!isSeatsUser) {
    return null;
  }
  return /*#__PURE__*/_jsx(StyledRouterSideNav, {
    routePath: "/commerce",
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.pagesV2.commerce.tabTitle"
    })
  });
};
export const BreezeIntelligenceSideNavItem = () => {
  return /*#__PURE__*/_jsx(StyledRouterSideNav, {
    routePath: "/breeze-intelligence",
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.pages.products.tabs.breeze-intelligence.tabTitle"
    })
  });
};
export const HubspotCreditsSideNavItem = () => {
  return /*#__PURE__*/_jsx(StyledRouterSideNav, {
    routePath: "/hubspot-credits",
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.pagesV2.hubspotCredits.tabTitle"
    })
  });
};
export const AddOnsSideNavItem = () => {
  return /*#__PURE__*/_jsx(StyledRouterSideNav, {
    routePath: "/add-ons",
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.pagesV2.add-ons.tabTitle"
    })
  });
};